import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDriverCreditEnums } from "../../Services/DriverCredit.service";

/**
 * Fetch driver credit enums (creditTypes + calculateTypes).
 * Cached — only hits the API once; pass forceRefresh=true to re-fetch.
 */
export const fetchDriverCreditEnums = createAsyncThunk(
  "driverCredit/fetchEnums",
  async (forceRefresh = false, { getState, rejectWithValue }) => {
    const { driverCredit } = getState();
    if (!forceRefresh && driverCredit.enumsLoaded) {
      return null; // already cached, skip the call
    }
    try {
      const resp = await getDriverCreditEnums();
      return {
        creditTypes: resp?.data?.creditTypes || {},
        calculateTypes: resp?.data?.calculateTypes || {},
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const driverCreditSlice = createSlice({
  name: "driverCredit",
  initialState: {
    creditTypes: {},
    calculateTypes: {},
    enumsLoaded: false,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDriverCreditEnums.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDriverCreditEnums.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.creditTypes = action.payload.creditTypes;
          state.calculateTypes = action.payload.calculateTypes;
          state.enumsLoaded = true;
        }
      })
      .addCase(fetchDriverCreditEnums.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default driverCreditSlice.reducer;
